import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-search-box',
    template: `
        <form class="k-form k-form-md" [formGroup]="searchForm">
            <div class="input-group">
                <input type="text" id="search" formControlName="search" class="form-control" [placeholder]="placeholder | translate" />
                <button *ngIf="searchForm.get('search')?.value" class="btn btn-outline-secondary btn clear-btn" type="button" (click)="clearSearch()">
                    <img class="icon" src="@imagesDir/cross.png" width="16px" height="16px" />
                </button>
                <button (click)="handleSearch()" class="btn btn-outline-secondary" type="button">
                    <img class="icon" src="@imagesDir/search.png" width="16px" height="16px" />
                </button>
            </div>
        </form>
    `,
    styles: [
        `
            .clear-btn {
                background: transparent;
                border: none;
                position: absolute;
                right: 50px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 5;
            }

            .input-group {
                position: relative;
                display: flex;
                align-items: center;
                width: 320px;
                max-width: 100%;
            }

            .form-control {
                width: calc(100% - 120px);
            }

            .btn {
                min-width: 40px;
            }
        `,
    ],
    standalone: false,
})
export class SearchBoxComponent {
    searchValue: string = 'datatable.search';
    @Output() search = new EventEmitter<string>();
    @Input() placeholder: string = this.searchValue;

    searchForm: FormGroup = new FormGroup({
        search: new FormControl(''),
    });

    handleSearch(): void {
        const value = this.searchForm.get('search')?.value;
        this.search.emit(value);
    }

    clearSearch(): void {
        this.searchForm.get('search')?.setValue('');
        this.search.emit('');
    }
}
